<template>
  <div id="content">
    <!-- 表格 -->
    <el-table :data="schArr" style="width: 100%">
      <el-table-column
        v-for="item in tableTitleList"
        :key="item.id"
        :label="item.name"
        align="center"
        :width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="scope.row[item.prop] == null">暂无数据</div>
          <div v-if="scope.row[item.prop] !== null">
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="
          this.status === 1 ||
            this.status === 2 ||
            this.status === 3 ||
            this.status === -1
        "

        label="退款/退货状态"
      >
        <template slot-scope="scope">
          {{ scope.row.returnStatusName ? scope.row.returnStatusName : '无' }}
        </template>
      </el-table-column>
      <!-- fixed="right" -->
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.showDetailBtn" size="mini" type="text" @click="handleEdit(scope.row)">
            详情
          </el-button>
          <el-dropdown v-if="scope.row.showPayBtn">
            <span class="el-dropdown-link">
              付款<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown" :popper-append-to-body="false" class="popper-dropdown">
              <template>
                <el-dropdown-item
                  v-for="department in scope.row.supPayType"
                  :key="department.value"
                  @click.native="getDepartment(scope.row, department.value)"
                >
                  {{ department.key }}
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="scope.row.showVoucherBtn"
            size="mini"
            type="text"
            @click="getDepartment(scope.row, '2')"
          >重传凭证
          </el-button>
          <template>
            <el-button
              v-if="scope.row.showReceiveBtn"
              size="mini"
              type="text"
              @click="handleReceive(scope.row)"
            >确认收货</el-button>
          </template>
          <template>
            <el-button
              v-if="scope.row.showRefundBtn"
              style="color: red"
              size="mini"
              type="text"
              @click="handleDialog(scope.row)"
            >申请退款</el-button>
          </template>
          <template>
            <el-button
              v-if=" scope.row.showCancelBtn"
              style="color: red"
              size="mini"
              type="text"
              @click="handleCancelDialog(scope.row.id)"
            >取消订单</el-button>
          </template>
          <template>
            <el-button
              v-if=" scope.row.showDeleteBtn"
              style="color: red"
              size="mini"
              type="text"
              @click="handleDeleteDialog(scope.row.id)"
            >删除订单</el-button>
          </template>
          <!-- 电子合同暂时隐藏 -->
          <template>
            <el-button v-if="scope.row.showSignContractBtn" :loading="scope.row.signLoading" size="mini" type="text" @click="getSignUrl(scope.row)">
              签署
            </el-button>
            <!-- <el-button v-if="scope.row.showContractRescissionBtn" size="mini" type="text" @click="showDialogRescission(scope.row)">
              解约
            </el-button> -->
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="block" style="margin-top: 15px">
      <el-pagination
        :current-page="orderParam.pageNum"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="orderParam.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 退款信息 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <span class="colorRed">*</span>请写清楚退款原因，待审核通过后再根据订单详情中的提示进行下一步操作，如有疑问，请与客服联系。
      <br>
      <br>
      <el-input
        v-model="textarea"
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        maxlength="200"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认收货提醒 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogReceive"
      width="40%"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="receive">
        <i class="el-icon-warning-outline font24" />
        <span>为了你的售后权益，请收到商品确认无误后再确认收货</span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel2">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 解约弹窗 -->
    <el-dialog title="发起解约" :visible.sync="dialogRescission" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
      <el-form ref="form" :model="form" size="small" label-width="140px">
        <el-form-item label="解约原因：" prop="rescindReason">
          <el-select
            v-model="form.rescindReason"
            placeholder="请选择"
          >
            <el-option
              v-for="item in rescindReasonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="解约说明：">
          <el-input
            v-model="form.rescindReasonNotes"
            type="textarea"
            placeholder="请输入"
            show-word-limit
            :maxlength="200"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRescission = false">取 消</el-button>
        <el-button :loading="rescissionLoading" type="primary" @click="handleRescission">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 确认跳转外部链接弹窗 -->
    <el-dialog title="即将离开终端优选平台" append-to-body :visible.sync="linkVisible" :close-on-click-modal="false" width="50%">
      <p>您即将使用E签宝进行电子签名操作，以完成您的相关流程</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkVisible = false">取 消{{ countDown }}</el-button>
        <el-button type="primary" @click="openUrl">继续访问</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderList,
  returnApplyCreate,
  orderConfirmReceiveOrder,
  orderCancelUserOrder,
  orderDeleteOrder,
  orderCount
} from '@/api/audit.js'
import { signUrlApi, getOrderContractInfoApi, signFlowRescissionApi } from '@/api/auth'
import { mapMutations } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: {
    status: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      schArr: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      orderParam: {
        pageNum: 1,
        pageSize: 10
      },
      tableData: {
        list: []
      },
      tableTitleList: [
        {
          prop: 'orderSn',
          name: '订单编号',
          width: ''
        },
        {
          prop: 'totalAmount',
          name: '订单总金额',
          width: '130'
        },
        {
          prop: 'payAmount',
          name: '应付金额',
          width: '130'
        },
        {
          prop: 'createTime',
          name: '下单时间',
          width: ''
        },
        {
          prop: 'statusLabel',
          name: '当前状态',
          width: ''
        }
      ],
      // 支付方式
      options: [
        {
          value: '0',
          label: '微信',
          payFlag: true
        },
        {
          value: '1',
          label: '支付宝',
          payFlag: true
        },
        {
          value: '2',
          label: '线下交易',
          payFlag: true
        }
      ],
      value: '',
      payFlag: true,
      orderFlag: false,
      dialogVisible: false,
      textarea: '',
      refundObj: {},
      disabledFlag: false,
      dialogReceive: false,
      receiveObj: {},
      form: {
        rescindReason: 1,
        rescindReasonNotes: ''
      },
      dialogRescission: false,
      rescissionLoading: false, // 解约loading
      rescindReasonOptions: [
        { label: '条款内容有误', value: 1 },
        { label: '印章选择错误', value: 2 },
        { label: '签署人信息错误', value: 3 },
        { label: '合作终止', value: 4 },
        { label: '其他', value: 5 }
      ],
      currentRow: {}, // 当前行
      ledFlag: this.$route.params.ledFlag,
      linkVisible: false,
      countDown: 30,
      url: ''
    }
  },
  mounted() {
    setTimeout(() => {
      const container = document.getElementById('content')
      // console.log('0229', container.scrollTo)
      container.scrollTo(0, 0)
    }, 3000)
    this.getOrderList()
    if (this.ledFlag === '1') {
      this.ledRestrict()
    }
  },
  methods: {
    ...mapMutations(['SET_TAB0', 'SET_TAB1', 'SET_TAB2', 'SET_TAB3', 'SET_TAB4']),
    openUrl() {
      window.location.href = this.url
    },
    // 显示解约弹窗
    showDialogRescission(row) {
      this.form.rescindReason = 1
      this.form.rescindReasonNotes = ''
      this.dialogRescission = true
      this.currentRow = row
    },
    // 获取合同解约链接
    async handleRescission() {
      this.rescissionLoading = true
      const infoParams = {
        orderSn: this.currentRow.orderSn
      }
      const infoRes = await getOrderContractInfoApi(infoParams)
      const rescissionParams = {
        rescindInitiator: 'portal',
        rescindReason: this.form.rescindReason,
        rescindReasonNotes: this.form.rescindReasonNotes,
        signFlowId: infoRes.data.signFlowId
      }
      const rescissionRes = await signFlowRescissionApi(rescissionParams)
      const params = {
        signFlowId: rescissionRes.data.signFlowId,
        redirectUrl: location.origin + '/#/home/myOrder'
      }
      const res = await signUrlApi(params)
      this.rescissionLoading = false
      this.url = res.data.shortUrl
      this.countDown = 30
      this.linkVisible = true
      const timer = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(timer)
          this.linkVisible = false
        } else {
          this.countDown--
        }
      }, 1000)
    },
    // 获取签署链接
    async getSignUrl(row) {
      row.signLoading = true
      const infoParams = {
        orderSn: row.orderSn
      }
      const infoRes = await getOrderContractInfoApi(infoParams)
      const params = {
        orderSn: row.orderSn,
        signFlowId: infoRes.data.signFlowId,
        redirectUrl: location.origin + '/#/home/myOrder'
      }
      const res = await signUrlApi(params)
      row.signLoading = false
      this.url = res.data.shortUrl
      this.countDown = 30
      this.linkVisible = true
      const timer = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(timer)
          this.linkVisible = false
        } else {
          this.countDown--
        }
      }, 1000)
    },
    // 根据分页设置的数据控制每页显示的数据条数及页码跳转页面刷新
    getPageData() {
      const start = (1 - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.tableData.list) {
        this.schArr = this.tableData.list.slice(start, end)
        this.$forceUpdate() // 强制更新组件
      } else {
        this.schArr = []
      }
    },
    // 每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.orderParam.pageNum = 1
      this.orderParam.pageSize = val
      this.getOrderList()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPageData()
      this.orderParam.pageNum = this.currentPage
      this.getOrderList()
    },
    // 点击详情
    handleEdit(row) {
      this.$router.push({
        path: '/home/auditDetail',
        query: {
          id: row.id, // 指定值或者获取的值
          status: this.status,
          currentPage: this.currentPage
        }
      })
    },
    // 获取订单列表
    getOrderList() {
      // console.log('this.status', this.status)
      const that = this
      this.orderParam = { ...this.orderParam, status: this.status }
      orderList(this.orderParam).then((response) => {
        if (response.data.list) {
          response.data.list.forEach((element) => {
            if (element.orderType === 0) {
              element.orderType = '正常订单'
            } else {
              element.orderType = '秒杀订单'
            }
            element.createTime = this.getTime(element.createTime)
            const statusArr = ['待付款', '待发货', '待收货', '已完成', '已关闭', '已取消', '待审核', '合同待审核', '合同被拒绝', '合同待签署', '预审核']
            element.statusLabel = statusArr[element.status]
            if (element.supPayType) {
              element.supPayType = JSON.parse(element.supPayType)
            }
            element.totalAmount = this.formatMoney(element.totalAmount)
            element.payAmount = this.formatMoney(element.payAmount)
            element.signLoading = false
          })

          // let supPayTypeArr = JSON.parse(element.supPayType)
          // supPayTypeArr.forEach((ele, index) => {
          //   if (ele == that.options[ele].value) {
          //     that.options[ele].payFlag = false;
          //   }
          // });
        }
        that.tableData.list = response.data.list
        that.total = response.data.total
        that.pageSize = response.data.pageSize
        that.currentPage = response.data.pageNum
        that.getPageData()
        this.$forceUpdate() // 强制更新组件
        // if (response.data.list !== undefined) {
        //   response.data.list.forEach(element => {
        //     if (this.status === 0) {
        //       that.SET_TAB0(response.data.total)
        //     } else if (this.status === 1) {
        //       that.SET_TAB1(response.data.total)
        //     } else if (this.status === 2) {
        //       that.SET_TAB2(response.data.total)
        //     } else if (this.status === 3) {
        //       that.SET_TAB3(response.data.total)
        //     } else if (this.status === -1) {
        //       that.SET_TAB4(response.data.total)
        //     }
        //   })
        // } else if (this.status === 0) {
        //   that.SET_TAB0(0)
        // } else if (this.status === 1) {
        //   that.SET_TAB1(0)
        // } else if (this.status === 2) {
        //   that.SET_TAB2(0)
        // } else if (this.status === 3) {
        //   that.SET_TAB3(0)
        // } else if (this.status === -1) {
        //   that.SET_TAB4(0)
        // }
      })
      this.$emit('customEvent')
    },
    // 自动补齐两位小数
    formatMoney(money) {
      const formattedMoney = parseFloat(money).toFixed(2)
      return '￥' + formattedMoney
    },
    getDepartment(val, item) {
      const orderParam = {}
      orderParam.pageNum = this.currentPage
      orderParam.pageSize = 10
      orderParam.status = this.status
      orderList(orderParam).then((response) => {
        let orderArr = []
        if (response.data.total > 0) {
          orderArr = response.data.list.filter((element) => {
            return val.id === element.id
          })
        } else {
          orderArr.length = 0
        }

        if (orderArr.length === 0) {
          this.$confirm('此订单付款状态已发生改变，请重新刷新页面', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }).then(() => {
            this.getOrderList()
          })
        } else {
          const operatorOrderList = [{}]
          operatorOrderList[0].confirmPay = false
          operatorOrderList[0].qrContent = ''
          operatorOrderList[0].showQr = false
          operatorOrderList[0].paySuccess = false
          operatorOrderList[0].image = ''
          this.$router.push({
            path: '/home/payment',
            query: {
              id: val.id, // 指定值或者获取的值
              payItem: item,
              status: this.status,
              currentStatus: val.status,
              page: this.currentPage,
              operatorOrderList: JSON.stringify(operatorOrderList)
            }
          })
        }
      })
    },
    // 转换时间
    getTime(val) {
      const dateString = val
      const date = new Date(dateString)

      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    handleDialog(val) {
      if (
        val.returnStatusName === '审核中' ||
        val.returnStatusName === '退货中'
      ) {
        this.$Message.warning('退款处理中，请稍后')
        // this.disabledFlag = true;
      } else if (val.returnStatusName === '已完成') {
        this.$Message.warning('退款处理结束')
      } else {
        // this.disabledFlag = false;
        this.dialogVisible = true
        this.refundObj = val
      }
    },
    handleClose(done) {
      done()
      this.textarea = ''
    },
    dialogCancel() {
      this.dialogVisible = false
      this.textarea = ''
    },
    dialogCancel2() {
      this.dialogReceive = false
    },
    dialogConfirm: debounce(function() {
      if (!this.textarea) {
        this.$message.error('请写明退款申请原因！！！')
        return false
      }

      const refund = {
        orderId: this.refundObj.id,
        orderSn: this.refundObj.orderSn,
        description: this.textarea
      }
      returnApplyCreate(refund).then((res) => {
        this.$message({
          message: '退款申请发起，请等待审核',
          type: 'success',
          duration: 1000
        })
        this.getOrderList()
        this.$forceUpdate()
      })
      this.dialogCancel()

      this.getOrderList()
    }, 800),
    // 确认收货
    handleReceive(val) {
      this.dialogReceive = true
      this.receiveObj = val
    },
    handleConfirm() {
      const orderObj = {
        orderId: this.receiveObj.id
      }
      orderConfirmReceiveOrder(orderObj).then((res) => {
        if (res.code === 200) {
          this.dialogReceive = false
          this.getOrderList()
          this.$forceUpdate()
        }
      })
    },
    // 取消订单
    handleCancelDialog(id) {
      this.$confirm('是否取消此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderCancelUserOrder({ orderId: id }).then(res => {
          if (res.code === 200) {
            this.getOrderList()
            this.$forceUpdate()
            this.$message({
              type: 'success',
              message: '取消成功!'
            })
          }
        }).catch(() => {
          this.getOrderList()
        })
      })
    },
    handleDeleteDialog(id) {
      this.$confirm('是否删除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderDeleteOrder({ orderId: id }).then(res => {
          if (res.code === 200) {
            this.getOrderList()
            this.$forceUpdate()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      })
    },
    // 更新订单数量
    getOrderCount() {
      orderCount().then(res => {
        // console.log('12', res)
      })
    },
    ledRestrict() {
      this.$confirm('根据平台规则限制，LED订单金额小于平台限制金额会进入预审核阶段，请耐心等待，稍后付款', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: false, // 不显示取消按钮
        showClose: false, // 是否显示右上角的x
        closeOnClickModal: false, // 是否可以点击空白处关闭弹窗
        type: 'warning'
      })
    }
  }
}
</script>
<style scoped>
.colorRed {
  color: red;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
  margin-left: 4px;
}
.el-icon-arrow-down {
  font-size: 12px;
  margin-right: 4px;
  margin-left: 2px;
}
.receive{
  display: flex;
  justify-content: center;
  font-size: 16px;
}
.font24{
  font-size: 24px;
  color: #f5a13a;
  margin-right: 10px;
}
</style>
